import { proxyClientInstance } from "../../wrappers/client";

export const getNotificationMessages = (personId) => {
  const getUrl = `/api/communication/v1/notifications/${personId}`;
  return proxyClientInstance.get(getUrl);
};